import React from 'react';
import Support from '../../shared/Support';
import useSessionEntity from '../../../hooks/useSessionEntity';

export default function CartCanceled() {
  const merchant = useSessionEntity('merchant');

  return (
    <div className="text-center" id="content">
      <h1 className="font-avenir-medium text-navy-blue text-2xl">This order has been canceled by {merchant.name}</h1>
      <p>
        If you still need to complete a transaction, please contact them to
        follow up.
      </p>

      <Support />
    </div>
  );
}
